module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('ul', {
    staticClass: "grid"
  }, [_c('h1', [_vm._v("HERE ALL BOOKS LIST")]), _vm._v(" "), _vm._l((_vm.books), function(m, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "kappa": m.bookName,
        "id": m.bookId,
        "src": _vm.$store.state.urlLink + m.bookId + '.png'
      },
      on: {
        "click": _vm.handleBookM
      }
    })])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c75e5ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ViewAll.vue
// module id = 1699
// module chunks = 1